import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { ButtonComponent } from '@app/shared/button/button.component';
import { RequestCodeApiService } from '@modules/sign-in/request-code-api.service';
import { NgxMaskModule } from 'ngx-mask';
import { TypeStep } from '../sign-up.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonComponent, NgxMaskModule],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  isSendCode = false;
  @Input() login: string;
  @Output() changeStepStatus = new EventEmitter<TypeStep>();

  constructor(private _requestCodeApiService: RequestCodeApiService) {}

  ngOnInit(): void {
  }

  stepBack() {
    this.changeStepStatus.emit('authorization');
  }

  sendCode() {
    this.isSendCode = true;
    this._requestCodeApiService.getVerificationCode({ login: this.login }).subscribe(() => {
      this.isSendCode = false;
      this.changeStepStatus.emit('confirmResetPassword');
    });
  }
}
